import { render, staticRenderFns } from "./VueMagnifier.vue?vue&type=template&id=f6b0fe36"
import script from "./VueMagnifier.vue?vue&type=script&lang=js"
export * from "./VueMagnifier.vue?vue&type=script&lang=js"
import style0 from "./VueMagnifier.vue?vue&type=style&index=0&id=f6b0fe36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports